import './Licenses.css'
import { ILicenseStats, ILicensesInfo } from 'src/Utils/Hooks/ManageLicenses/useGetLicensesInfo';
import LicenseInfo from '../LicenseInfo/LicenseInfo';
import LicensesInstruction from './LicensesInstruction';
import { useEffect, useState } from 'react';
import { InfoMessageType } from 'src/Components/InfoBar/InfoBar';

interface ILicensesParams {
    licensesInfo: ILicensesInfo;
    clinicId: string;
    setInfo: (message: string, type: InfoMessageType) => void;
    updatePageLoader: (load: boolean) => void;
    isSuiteLicense: boolean;
}
const Licenses: React.FC<ILicensesParams> = ({ licensesInfo, clinicId, setInfo, updatePageLoader, isSuiteLicense }) => {
    const [updatedLicenceInfo, setUpdatedLicenceInfo] = useState<ILicensesInfo>(licensesInfo);
    const [licenseStatistics, setLicenseStatistics] = useState<ILicenseStats>({ total: 0, inUse: 0 });

    useEffect(() => {
        var total = updatedLicenceInfo.clinicUserAndStorageLicenseInfo.maximumSeats;
        var inUse = updatedLicenceInfo.clinicUserAndStorageLicenseInfo.maximumSeats - updatedLicenceInfo.clinicUserAndStorageLicenseInfo.availableSeats;
        setLicenseStatistics({ total, inUse });
    }, [updatedLicenceInfo])
    
    useEffect(() => {
        setUpdatedLicenceInfo(licensesInfo)
    }, [licensesInfo])


    return (
        <>
            {licenseStatistics.total > 0 &&
                <>
                    <div className="row">
                        <div className='col instruction'>
                            {(licenseStatistics.inUse > 0) && (licenseStatistics.inUse === licenseStatistics.total) &&
                                <LicensesInstruction />
                            }
                        </div>
                    </div>
                    <div>
                        {
                            <LicenseInfo
                                licensesList={updatedLicenceInfo.clinicLicenceUserInfo}
                                noOfUnusedLicenses={licenseStatistics.total - licenseStatistics.inUse}
                                licenseEndDate={updatedLicenceInfo.clinicUserAndStorageLicenseInfo.licenseEndDate}
                                clinicId={clinicId}
                                setInfo={setInfo}
                                updatePageLoader={updatePageLoader}
                                licenseStatistics={licenseStatistics}
                                isSuiteLicense={isSuiteLicense}
                            />
                        }
                    </div>
                </>
            }
        </>
    )
}

export default Licenses